import uiCore = require("../../core/uicore");
import entityCache = require("../../core/entitycache");
import entityHelper = require("../../core/entityhelper");

export class JobTitleNew implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "personjobtitlesnew",
        Url: "/{personId:int}/jobtitles/new",
        HeaderText: "Resources &raquo; Persons &raquo; Jobtitles",
        StateString: "resources.personsjobtitlesnew",
        Template: require("./jobtitles.new.html"),
        AngularDependencies: [{ $angularInjectionId: "$mdDialog" }, { $angularInjectionId: "$state" }, { $angularInjectionId: "$stateParams" }, { $angularInjectionId: "$scope" }]
    }

    public jobtitle: Nema.Crew.Model.PersonJob;
    protected dataCache: entityCache.EntityCache;
    public $mdDialog: ng.material.IDialogService;
    private $state: ng.ui.IStateService;
    public jobTitleList: Nema.Crew.Model.JobType[];
    public searchTextJobTitle: string;
    public person: Nema.Crew.Model.Person;

    constructor($mdDialog, $state, $stateParams, $scope, ..._args: any[]) {
        var self = this;
        self.$mdDialog = $mdDialog;
        self.$state = $state;
        var personId = (<NewJobTitleStateParams><any>$stateParams).personId;
        self.dataCache = new entityCache.EntityCache(entityCache.CommonEntityManagers.EntityManager);
        var scope = $scope;
        self.searchTextJobTitle = "";

        var dataDependencies: string[] = [
            entityCache.EntityTypeNames.Person,
            entityCache.EntityTypeNames.PersonJob,
            entityCache.EntityTypeNames.JobType,
        ];
        var entitiesPromise = self.dataCache.getEntitySetsPromise(dataDependencies);

        entitiesPromise.then(_res => {
            self.jobTitleList = <any> self.dataCache.searchActiveByName(entityCache.EntityTypeNames.JobType, "");
            self.person = <any>self.dataCache.getEntity(entityCache.EntityTypeNames.Person, personId);
            self.jobtitle = <any>self.dataCache.entityManager.createEntity(entityCache.EntityTypeNames.PersonJob, <Nema.Crew.Model.PersonJob>{
                JobType: self.jobTitleList[0],
                JobTypeId: self.jobTitleList[0].Id,
                Person: self.person,
                PersonId: self.person.Id,
                FromDate: new Date(new Date(Date.now()).setHours(0,0,0,0))
            });
            scope.$apply();
        });

    }


    public save() {

        var listOfChanges = [
            () => { }
        ];

        entityHelper
            .saveSequentialListOfChangesAndNavigate(
            listOfChanges,
            this.dataCache.entityManager,
            () => { this.goToPersonPage(this.$state) },
            this.$state);
    }

    public cancel() {
        this.goToPersonPage(this.$state);
    }

    public goToPersonPage(state: ng.ui.IStateService) {
        state.go("app.resources.persons.detail", { personId: this.jobtitle.Person.Id });
    }

    public searchJobTypes(searchString: string): Nema.Crew.Model.JobType[] {
        return <any[]> this.dataCache.searchActiveByName(entityCache.EntityTypeNames.JobType, searchString);
    }
}

export class NewJobTitleStateParams {
    personId: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/jobtitles/jobtitles.new.ts